import React from 'react';
import { FaFilePdf } from 'react-icons/fa';
import demo from '../../assets/documents/CourtOrders.zip';
import demo1 from '../../assets/documents/Dark Sky Compliant-light Illumination.pdf';
import { useSelector } from 'react-redux';
import { convertToMarathiNumber } from '../../components/marathiNumbers';
import { Link } from 'react-router-dom';

const Resoultions = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);

    const content = {
        English: {
            title: "Government Resolutions",
            breadcrumb: {
                home: "HOME",
                page: "GOVERNMENT RESOLUTIONS",
            },
        },
        मराठी: {
            title: "शासन निर्णय",
            breadcrumb: {
                home: "मुख्यपृष्ठ ",
                page: "शासन निर्णय",
            },
        },
    };
    const t = content[selectedLang];

    const tableHeaders = {
        srNo: {
            English: "Sr. No.",
            मराठी: "अ.क्र.",
        },
        name: {
            English: "Name",
            मराठी: "नाव",
        },
        download: {
            English: `Download`,
            मराठी: `डाउनलोड`,
        },
    };

    const documents = [
    {
        id: 1,
        name: {
            English: "Removal of Encroachments on Forts",
            मराठी: "गड- किल्ल्यांवर अतिक्रमण दूर करणेबाबत",
        },
        file: demo,
    },
    {
        id: 2,
        name: {
            English: "Guidelines and Circular for Implementing Artificial Lighting on Monuments",
            मराठी: "स्मारकांवर कृत्रिम प्रकाश योजना करण्यासाठी मार्गदर्शक सूचना व परिपत्रक",
        },
        file: demo1, // change if you have a different file
    }
];

    return (
        <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
            {/* Page Title and Breadcrumb */}
            <div className="text-center mb-8">
                <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
                    {t.title}
                </h1>
                <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
                    <span style={{ color: "#DD9827" }}>
                        <Link to="/" className="hover:underline">
                            {t.breadcrumb.home}
                        </Link>{" "}/{" "}</span>
                    {t.breadcrumb.page}
                </p>
            </div>

            {/* Table Section */}
            <div className="max-w-5xl mx-auto overflow-x-auto">
                <div
                    className="bg-[#EFEDE0] rounded-xl overflow-hidden no-dark-bg"
                    style={{ border: "2px solid #F8D6BF" }}
                >
                    <table className="min-w-full text-center text-black text-sm sm:text-base">
                        <thead className='font-bold tracking-wide' style={{
                            textShadow: '0.3px 0.3px 0 black',
                        }}>
                            <tr>
                                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.srNo[selectedLang]}
                                </th>
                                <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.name[selectedLang]}
                                </th>
                                <th className="py-3 px-4" style={{ borderColor: '#F8D6BF' }}>
                                    {tableHeaders.download[selectedLang]}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {documents.map((doc, index) => (
                                <tr key={doc.id} className="hover:bg-[#F6F6EC]">
                                    <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {selectedLang === 'मराठी' ? convertToMarathiNumber(index + 1) : `${index + 1}`}.
                                    </td>
                                    <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                        {doc.name[selectedLang]}
                                    </td>
                                    <td className="py-3 px-4 border-t-2" style={{ borderColor: '#F8D6BF' }}>
                                        <div className="flex justify-center items-center h-full">
                                            <a
                                                href={doc.file}
                                                download
                                                title="Download File"
                                                className="text-red-600 hover:text-red-800"
                                            >
                                                <FaFilePdf size={20} />
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
};

export default Resoultions;
